(function() {
	'use strict';

	angular.module('quantixApp').factory('InsightsService',
			InsightsService);

	InsightsService.$inject = [ '$resource', '$q', '$http' ];

	function InsightsService($resource, $q, $http) {
		
		  var _getInsightDetailsForIndustryProfile=function(moduleName,id){
			  var data={
					  moduleName : moduleName,
					  industryId:id
			  }
			  var deferred = $q.defer();
				
				var url = 'api/insights/getInsights';

				$http.post(url,data).then(function(response) {
					deferred.resolve(response);

				}, function(errResponse) {
					deferred.reject(errResponse);
				});

				return deferred.promise;
			}
		  
		  var _getInsightDetailsForCompanyProfile=function(moduleName,companyCode){
			  var data={
					  moduleName : moduleName,
					  companyCode:companyCode
			  }
			  var deferred = $q.defer();
				
				var url = 'api/insights/getInsightsForCompanyProfile';

				$http.post(url,data).then(function(response) {
					deferred.resolve(response);

				}, function(errResponse) {
					deferred.reject(errResponse);
				});

				return deferred.promise;
			}
		  var _getInsightDetailsForHomeIndustryProfile=function(moduleName){
			  var data={
					  moduleName : moduleName
			  }
			  var deferred = $q.defer();
				
				var url = 'api/insights/getInsightsForHomeIndustryProfile';

				$http.post(url,data,{ignoreLoadingBar : true }).then(function(response) {
					deferred.resolve(response);

				}, function(errResponse) {
					deferred.reject(errResponse);
				});

				return deferred.promise;
			}
	  
		return {
			getInsightDetailsForIndustryProfile   : _getInsightDetailsForIndustryProfile,
			getInsightDetailsForCompanyProfile:_getInsightDetailsForCompanyProfile,
			getInsightDetailsForHomeIndustryProfile:_getInsightDetailsForHomeIndustryProfile
			
			
		};

	}
})();